var exports = {
  "e6": "ChannelItem.module__channelItemCore___WTd5U3",
  "$H": "ChannelItem.module__channelItemCoreSelected___WTd5U3",
  "_B": "ChannelItem.module__channelItemCoreUnselected___WTd5U3",
  "Vp": "ChannelItem.module__channelItemCoreHovered___WTd5U3",
  "TV": "ChannelItem.module__typingTooltip___WTd5U3",
  "kp": "ChannelItem.module__channelTypingIndicator___WTd5U3",
  "IM": "ChannelItem.module__typingIndicatorIcon___WTd5U3",
  "U4": "ChannelItem.module__channelItemSelected___WTd5U3",
  "OI": "ChannelItem.module__typingAvatars___WTd5U3",
  "_N": "ChannelItem.module__channelItemIcon___WTd5U3",
  "Jz": "ChannelItem.module__channelItemIconSelected___WTd5U3",
  "Wk": "ChannelItem.module__categoryContainer___WTd5U3",
  "yb": "ChannelItem.module__categoryName___WTd5U3",
  "zc": "ChannelItem.module__iconContainer___WTd5U3",
  "HA": "ChannelItem.module__channelName___WTd5U3",
  "Hq": "ChannelItem.module__actionsContainer___WTd5U3",
  "OO": "ChannelItem.module__channelItemIconUnselected___WTd5U3",
  "Cr": "ChannelItem.module__channelItemIconHighlight___WTd5U3",
  "rC": "ChannelItem.module__channelItemLabel___WTd5U3",
  "gw": "ChannelItem.module__channelItemActions___WTd5U3",
  "kL": "ChannelItem.module__container___WTd5U3",
  "YI": "ChannelItem.module__channelReorderTarget___WTd5U3",
  "c2": "ChannelItem.module__channelCategoryReorderTarget___WTd5U3",
  "XE": "ChannelItem.module__unreadIndicator___WTd5U3",
  "_j": "ChannelItem.module__unreadIndicatorMuted___WTd5U3",
  "fc": "ChannelItem.module__channelItem___WTd5U3",
  "Z$": "ChannelItem.module__channelItemCategory___WTd5U3",
  "RQ": "ChannelItem.module__channelItemRegular___WTd5U3",
  "zx": "ChannelItem.module__channelItemHighlight___WTd5U3",
  "_R": "ChannelItem.module__channelItemMuted___WTd5U3",
  "Td": "ChannelItem.module__channelItemSelectedWithUnread___WTd5U3",
  "Fb": "ChannelItem.module__channelItemHoverable___WTd5U3",
  "FN": "ChannelItem.module__channelItemPressed___WTd5U3",
  "Je": "ChannelItem.module__channelItemOver___WTd5U3",
  "X9": "ChannelItem.module__channelItemContextMenu___WTd5U3",
  "L5": "ChannelItem.module__channelItemCategoryContextMenu___WTd5U3",
  "GJ": "ChannelItem.module__channelItemDragging___WTd5U3",
  "rO": "ChannelItem.module__channelItemDimmed___WTd5U3",
  "x1": "ChannelItem.module__channelItemMutedState___WTd5U3",
  "Ef": "ChannelItem.module__hoverAffordance___WTd5U3",
  "Mn": "ChannelItem.module__keyboardFocus___WTd5U3",
  "BE": "ChannelItem.module__channelItemAutocompleteHighlight___WTd5U3",
  "Yq": "ChannelItem.module__categoryContent___WTd5U3",
  "Yl": "ChannelItem.module__categoryIcon___WTd5U3",
  "Sk": "ChannelItem.module__createChannelButton___WTd5U3",
  "$Z": "ChannelItem.module__createChannelIcon___WTd5U3",
  "Ne": "ChannelItem.module__voiceUserCount___WTd5U3",
  "p9": "ChannelItem.module__channelItemVoice___WTd5U3",
  "pL": "ChannelItem.module__contextMenuOpen___WTd5U3",
  "jL": "ChannelItem.module__channelItemHoverAffordancesActive___WTd5U3",
};

module.exports = exports;
